import {
    FETCH_SUPPLIER_REQUEST,
    FETCH_SUPPLIER_SUCCESS,
    FETCH_SUPPLIER_FAILURE,
  } from "./AutoCompleteSupplierTypes";
  import api from "../../utils/Api";
  
  export const fetchSupplierRequest = () => {
    return {
      type: FETCH_SUPPLIER_REQUEST,
    };
  };
  
  export const fetchSupplierSuccess = (supplier) => {
    return {
      type: FETCH_SUPPLIER_SUCCESS,
      payload: supplier,
    };
  };
  
  export const fetchSupplierFailure = (error) => {
    return {
      type: FETCH_SUPPLIER_FAILURE,
      payload: error,
    };
  };
  
  export const fetchSupplier = (supplier_name) => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    return async (dispatch) => {
      dispatch(fetchSupplierRequest);
      try {
        const response = await api.get(
          "relatedparty/supplier/autocomplete?supplier_name=" + supplier_name,
          {
            headers: headers,
          }
        );
  
        const supplier = response.data.data;
        //console.log("******* supplier autocomplete - ", supplier);
        dispatch(fetchSupplierSuccess(supplier));
      } catch (error) {
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchSupplierFailure(errorMsg));
      }
    };
  };
  